import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { CurrencyVariableScaleDisplay } from "commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { type INumberResponse } from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrency";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

class CurrencyVariableScaleCell extends PureComponent<
    IGridCellRenderProps<INumberResponse | undefined>
> {
    render() {
        const { cellValue } = this.props;
        if (!cellValue) {
            return null;
        }

        if (cellValue) {
            return cellValue.value !== undefined && cellValue.value !== null ? (
                <CurrencyVariableScaleDisplay
                    value={cellValue.value}
                    decimalScale={cellValue.scale}
                />
            ) : null;
        }
        return null;
    }
}

export const columnCurrencyVariableScale: IClientGridColumn<INumberResponse | undefined> = {
    validationSchema: yup.object<INumberResponse>({
        value: yup.number(),
        scale: yup.number(),
    }),
    columnType: GridColumnType.currencyVariableScale,
    Cell: CurrencyVariableScaleCell,
};
